import { useEffect, useState } from 'react';
import { navLinks } from '../data/siteData';
import BrandMark from './BrandMark';
import './StickyNav.css';

function StickyNav() {
  const [visible, setVisible] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const hero = document.getElementById('top');
    if (!hero) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => setVisible(!entry.isIntersecting),
      { rootMargin: '-72px 0px 0px 0px', threshold: 0 }
    );

    observer.observe(hero);
    return () => observer.disconnect();
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <div className={`sticky-nav ${visible ? 'is-visible' : ''}`}>
      <div className="sticky-nav-inner">
        <a href="#top" className="sticky-brand" onClick={closeMenu}>
          <BrandMark />
          <span className="sticky-brand-name">Sundaravel Group</span>
        </a>

        <nav className={`sticky-links ${menuOpen ? 'is-open' : ''}`}>
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              target={link.external ? '_blank' : undefined}
              rel={link.external ? 'noopener noreferrer' : undefined}
              onClick={closeMenu}
            >
              {link.label}
            </a>
          ))}
          <a href="#contact" className="btn btn-primary sticky-cta" onClick={closeMenu}>
            Contact Us
          </a>
        </nav>

        <button
          className={`sticky-menu-toggle ${menuOpen ? 'is-open' : ''}`}
          aria-label="Toggle navigation menu"
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>
    </div>
  );
}

export default StickyNav;
